const _wrapParameter = (name) => `$${name}$`;
const _parameterResult = (parameter, score = 1) => {
  var _a;
  const name = _wrapParameter(parameter.name);
  const description = ((_a = parameter.description) == null ? void 0 : _a.length) > 0 ? ` - ${parameter.description}` : "";
  return {
    name,
    value: name,
    score,
    meta: `parameter${description}`
  };
};
const ParameterCompletion = {
  getCompletions: ({ prefix, view }) => {
    var _a;
    const parameters = (_a = view == null ? void 0 : view.search) == null ? void 0 : _a.parameters;
    return parameters == null ? void 0 : parameters.filter(({ name }) => _wrapParameter(name).indexOf(prefix) >= 0).map((parameter) => _parameterResult(parameter)).toArray();
  }
};
export default ParameterCompletion;
